import { Directive, HostListener, Input, ElementRef, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';

@Directive({
	selector: 'img[appImageFallback]' // only applies to <img> elements
})
export class ImageFallbackDirective implements OnInit {

	/** Allow optional override */
	@Input() appImageOnErrorFallback: string;

	constructor(private el: ElementRef<HTMLImageElement>) { }

	ngOnInit() {
		if (!this.appImageOnErrorFallback) {
			this.appImageOnErrorFallback = environment.defaultImagePath + environment.defaultNoImage ||
				'https://stmgwebappstorage.blob.core.windows.net/prismpdm/assets/noimage.png';
		}
	}

	@HostListener('error')
	onError(): void {
		const img = this.el.nativeElement;
		if (img.src !== this.appImageOnErrorFallback) {
			img.src = this.appImageOnErrorFallback;
		}
	}
}
